import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ChevronDown from '@johnlewispartnership/wtr-ingredients/dist/Icon/ChevronDown';
import style from './index.scss';
function CarouselExpansionButton({ setIsOpen, isOpen }) {
    return (React.createElement("div", { className: classNames('visible-xs-block', style.hide, style.buttonWrapper, {
            [style.buttonWrapperOpen]: isOpen,
        }) },
        React.createElement("button", { "aria-label": "Click to show associated products", className: classNames(style.roundButton, { [style.roundButtonOpen]: isOpen }), "data-testid": "carousel-expansion-button", type: "button", onClick: () => {
                setIsOpen(!isOpen);
            } },
            React.createElement(ChevronDown, null))));
}
CarouselExpansionButton.propTypes = {
    setIsOpen: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
};
export default CarouselExpansionButton;
//# sourceMappingURL=index.js.map